const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Forma-1",
    serifId: "Forma 1",
    transform: "matrix(1,0,0,1,-1281,-31.9992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1301.49,35.51C1296.81,30.828 1289.19,30.828 1284.51,35.51C1279.83,40.19 1279.83,47.808 1284.51,52.489C1286.85,54.83 1289.92,56 1293,56C1296.08,56 1299.15,54.83 1301.49,52.489C1306.17,47.808 1306.17,40.19 1301.49,35.51ZM1293,52.004C1292.45,52.004 1292,51.556 1292,51.003C1292,50.451 1292.45,50.003 1293,50.003C1293.55,50.003 1294,50.451 1294,51.003C1294,51.556 1293.55,52.004 1293,52.004ZM1294,47.001C1294,47.553 1293.55,48.002 1293,48.002C1292.45,48.002 1292,47.553 1292,47.001L1292,36.996C1292,36.443 1292.45,35.995 1293,35.995C1293.55,35.995 1294,36.443 1294,36.996L1294,47.001Z",
    style: {
      fill: "rgb(255,191,7)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.2f7a34a046ed77c681c3a5e53b1d7e84.svg";
export { ForwardRef as ReactComponent };